import React from 'react'

export default function RightCol({ children }) {
  return <div className="col-xl-9">{children}</div>
}
